import { S1ClientInfo } from "./s1-clientinfo";
import { S1LoginCredentials } from "./s1-logincredentials";

export class LoginRequest {
    clientInfo:S1ClientInfo;
    loginCredentials:S1LoginCredentials;
}